
import { Vue, Component, Ref, Watch } from 'vue-property-decorator';
import lazyInject from '@/di';
import CarService from '@/services/car.service';
import { CarBrand } from '@/models/brand.model';
import CarRecordingDrawer from './components/CarRecordingDrawer.vue';
import {
  AuthEnum,
} from '@/services/permission.service';

@Component({
  components: {
    CarRecordingDrawer,
  },
})
export default class brandIndex extends Vue {
  @lazyInject(CarService)
  carService!: CarService;

  @Ref('carRecordingDrawer')
  carRecordingDrawer!: CarRecordingDrawer;

  AuthEnum = AuthEnum;

  pagination = {
    total: 0,
    current: 1,
    pageSize: 10,
    showSizeChanger: true,
    pageSizeOptions: this.$store.state.pageSize.pageSize,
    onShowSizeChange: this.onShowSizeChange,
    onChange: this.paginationChange,
    showTotal: (total: any) => `共 ${total} 条`,
  };

  columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      ellipsis: true,
      align: 'center',
      width: 100,
    },
    {
      title: '品牌名称',
      dataIndex: 'name',
      key: 'name',
      ellipsis: true,
      align: 'center',
      width: 160,
    },
    {
      title: 'brandcode',
      dataIndex: 'brandcode',
      key: 'brandcode',
      align: 'center',
      width: 180,
    },
    {
      title: '品牌logo',
      dataIndex: 'logo',
      key: 'logo',
      ellipsis: true,
      scopedSlots: { customRender: 'logo' },
      align: 'center',
      width: 160,
    },
    {
      title: '头图',
      dataIndex: 'headlineImage',
      key: 'headlineImage',
      ellipsis: true,
      scopedSlots: { customRender: 'headlineImage' },
      align: 'center',
      width: 160,
    },

    {
      title: '服务商名称',
      dataIndex: 'serviceProvider',
      key: 'serviceProvider',
      ellipsis: true,
      align: 'center',
      width: 160,
    },
    {
      title: '主账号',
      dataIndex: 'primaryAccount',
      key: 'primaryAccount',
      ellipsis: true,
      align: 'center',
      width: 180,
    },
    {
      title: '品牌管理员',
      dataIndex: 'brandAdmin',
      key: 'brandAdmin',
      align: 'center',
      width: 180,
    },
    {
      title: '门店数量',
      dataIndex: 'shopNum',
      key: 'shopNum',
      ellipsis: true,
      align: 'center',
      width: 100,
    },
    {
      title: '创建时间',
      dataIndex: 'createTime',
      key: 'createTime',
      align: 'center',
      width: 160,
    },
    {
      title: '操作',
      dataIndex: 'action',
      fixed: 'right',
      key: 'action',
      scopedSlots: { customRender: 'action' },
      align: 'center',
      width: 240,
    },
  ];

  listData = [];

  form: any = {
    kaName: '',
    brandCode: '',
  };

  @Watch('$route')
  handleSearch() {
    const { page, pageSize, kaName, brandCode } = this.$route.query;

    const query: any = {
      pageSize: pageSize || 10,
      page: page || 1,
    };
    if (kaName) {
      query.brand_name = kaName;
      this.form.kaName = kaName;
    }
    if (brandCode) {
      query.brand_code = brandCode;
      this.form.brandCode = brandCode;
    }
    this.getList(query);
  }

  onShowSizeChange(current: number, pageSize: number) {
    this.pagination.current = 1;
    this.pagination.pageSize = pageSize;
    this.assembleRouting();
  }

  paginationChange(page: number, pageSize: number) {
    this.pagination.current = page;
    this.pagination.pageSize = pageSize;
    this.assembleRouting();
  }

  search() {
    this.pagination.current = 1;
    this.assembleRouting();
  }

  assembleRouting() {
    const { kaName, brandCode } = this.form;
    const { current, pageSize } = this.pagination;
    const query: any = {
      page: current,
      pageSize,
      timestamp: Math.round(Date.now() / 1000),
    };
    if (kaName) {
      query.kaName = kaName;
    }
    if (brandCode) {
      query.brandCode = brandCode;
    }
    this.$router.push({
      query,
    });
  }

  resetQuery() {
    this.form = {
      kaName: '',
      brandCode: '',
    };
    this.pagination.current = 1;
    this.assembleRouting();
  }

  async getList(item: any) {
    const res = await this.carService.getCarKaList(item);
    console.log(res);
    if (res) {
      this.listData = res.list.map((data: any) => {
        return CarBrand.from(data);
      });
      this.pagination.current = res.page;
      this.pagination.total = res.total;
    }
  }

  async mounted() {
    this.handleSearch();
  }

  async funAction(item: any) {
    console.log(item);
    this.carRecordingDrawer.open(item);
    // console.log(item);
    // const res = await this.carService.getCarKaAudioList({ car_ka_id: item.id });
    // console.log(res);
  }
}
